import React, { useEffect, useState, useRef } from "react";
import { Card, Input, Button, Flex, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import {
  useFetchAllergyBySearchMutation,
  useDeleteAllergyMutation,
  useFetchAllergyChartQuery,
  useUploadAllergyChartMutation,
} from "./allergy.service";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "./style.css";

export default function AllergyCheck() {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const navigate = useNavigate();
  const [isChartModalVisible, setIsChartModalVisible] = useState(false);

  const [
    requestFetchAllergyBySearch,
    {
      data: allergyDataBySearch = {
        dishesWithAllergens: [],
        dishesWithoutAllergens: [],
      },
      isSuccess: isFetchBySearchSuccess,
    },
  ] = useFetchAllergyBySearchMutation();
  const [pdfName, setPdfName] = useState(null);
  const fileInputRef = useRef(null);

  const { data: allergyChartUrl, isLoading: isChartLoading } =
    useFetchAllergyChartQuery();

  const [deleteAllergy, { isLoading: isDeleteLoading }] =
    useDeleteAllergyMutation();

  const [uploadAllergyChart] = useUploadAllergyChartMutation();

  const [allergens, setAllergens] = useState();

  const handleSearch = () => {
    requestFetchAllergyBySearch({ allergens });
  };

  const handleDeleteAllergy = async (id) => {
    try {
      await deleteAllergy(id);
      toast.success(t("Allergy deleted successfully"));
      handleSearch(); // Refresh the list after deletion
    } catch (error) {
      toast.error(t("Failed to delete allergy"));
    }
  };

  const handleEditAllergy = (id) => {
    navigate(`/allergy/edit/new/${id}`);
  };

  const handleShowChart = () => {
    if (allergyChartUrl) {
      setIsChartModalVisible(true);
    } else {
      toast.error(t("Allergy chart not available"));
    }
  };

  const triggerPDFUpload = () => {
    fileInputRef.current?.click();
  };

  const handlePDFChange = (event, id) => {
    const file = event.target.files[0];
    if (file && file.type === "application/pdf") {
      try {
        setPdfName(file.name);
        const response = uploadAllergyChart(file).unwrap();
        console.log("Upload successful:", response);
      } catch (err) {
        console.error("Upload failed:", err);
      }
    }
  };

  useEffect(() => {
    if (!allergens || allergens === "") {
    }
  }, [allergens]);

  const { dishesWithAllergens, dishesWithoutAllergens } = allergyDataBySearch;

  return (
    <Card
      title={`${t("ALLERGY")} ${t("LIST")}`}
      className="allergy-page"
      extra={
        <Flex justify="center">
          <Button type="primary" onClick={() => navigate("/allergy/create")}>
            {t("CREATE")}
          </Button>
        </Flex>
      }
    >
      <div className="allergy-page-container">
        <div className="allergy-page-container-search">
          <div className="allergy-page-container-search-label">
            {t("CUSTOMER ALLERGY")}
          </div>
          <div className="allergy-page-container-search-input">
            <Input
              size="small"
              onChange={(e) => setAllergens(e.target.value)}
            />
          </div>
          <div className="allergy-page-container-search-button">
            <Button onClick={handleSearch} size="small" type="primary">
              {t("SEARCH")}
            </Button>
            <Button
              color="green"
              style={{ marginLeft: "10px" }}
              variant="solid"
              onClick={() => navigate("/allergy/edit/new")}
            >
              {t("EDIT")}
            </Button>

            <Button
              color="grey"
              style={{ marginTop: "2px", marginLeft: "10px" }}
              variant="solid"
              onClick={triggerPDFUpload}
            >
              <svg
                viewBox="0 0 22 22"
                style={{
                  width: "12px",
                  height: "12px",
                  marginRight: "5px",
                  fill: "currentColor",
                }}
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM13 9V3.5L18.5 9H13zM12 18v-4H9l4-4 4 4h-3v4h-2z" />
              </svg>
              {pdfName ? `${t("Uploaded")}: ${pdfName}` : t("Upload PDF")}
              <input
                type="file"
                accept=".pdf"
                ref={fileInputRef}
                onChange={(event) => handlePDFChange(event, "test")}
                style={{ display: "none" }}
              />
            </Button>
          </div>
        </div>
        <div className="allergy-page-container-result">
          <span className="allergy-page-container-result-title">
            {t("RESULTS NOT INCLUDING ALLERGY INGREDIENT")}
          </span>
          {dishesWithoutAllergens.map((item, key) => (
            <div key={key} className="allergy-page-container-result-item">
              <p
                className="allergy-page-container-result-content"
                onClick={() => handleEditAllergy(item._id)}
                style={{ cursor: "pointer" }}
              >
                {t(item[`name_${language}`])}
              </p>
            </div>
          ))}
        </div>
        <div className="allergy-page-container-result">
          <span className="allergy-page-container-result-notitle">
            {t("RESULTS INCLUDING ALLERGY INGREDIENT")}
          </span>
          {dishesWithAllergens.map((item, key) => (
            <div key={key} className="allergy-page-container-result-item">
              <p
                className="allergy-page-container-result-content"
                onClick={() => handleEditAllergy(item._id)}
                style={{ cursor: "pointer" }}
              >
                {t(item[`name_${language}`])}
              </p>
            </div>
          ))}
        </div>
      </div>

      <Modal
        title={t("ALLERGY CHART")}
        open={isChartModalVisible}
        onCancel={() => setIsChartModalVisible(false)}
        footer={null}
        width="80%"
        style={{ top: 20 }}
      >
        {allergyChartUrl && (
          <iframe
            src={allergyChartUrl}
            style={{ width: "100%", height: "80vh", border: "none" }}
            title="Allergy Chart"
          />
        )}
      </Modal>
    </Card>
  );
}
